<fd-dynamic-page>
  <fd-dynamic-page-header />
  <fd-dynamic-page-content style="margin: auto">
    <figure fd-illustrated-message [svgConfig]="config()">
      <figcaption fd-illustrated-message-figcaption>
        <h3
          fd-illustrated-message-title
          [innerHTML]="config().illustratedMessageTitle"
        ></h3>
        <p
          fd-illustrated-message-text
          [innerHTML]="config().illustratedMessageText"
        ></p>
      </figcaption>
      <fd-illustrated-message-actions>
        <button
          fd-button
          fdType="emphasized"
          glyph="inspect"
          glyphPosition="after"
          label="Configure"
          [fdCompact]="true"
          (click)="link()"
        ></button>
      </fd-illustrated-message-actions>
    </figure>
  </fd-dynamic-page-content>
</fd-dynamic-page>
